import React, { useState, useEffect } from "react";
import {
    Grid,
    Container,
    TableCell,
    TableRow,
    Table,
    TableHead,
    TableBody,
    TextareaAutosize,
    Button,
    TextField,
    Stack,
    Alert,
    CircularProgress
} from "@mui/material";
import { axiosFetch } from "../../../../../utils/AxiosFetch";
import { useNavigate, useParams } from 'react-router';
import { useDispatch } from "react-redux";
import Select from 'react-select';
import { NumericFormat } from 'react-number-format';
import { SnackbarActions } from "../../../../../redux/actions/snackbar.actions";
import { CustomizedSnackbar } from "../../../../../shared";
import './Form.css';

let orginialData;
const ValueAnalysisForm = () => {


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();




    const [scores, setScores] = useState([]);
    const [profileDetail, setProfileDetail] = useState(null);
    const [employeeId, setEmployeeId] = useState("");
    const [reportingPersonId, setReportingPersonId] = useState("");
    const [marketRate, setMarketRate] = useState("");
    const [ctc, setCTC] = useState("");
    const [employeeCircumstance, setEmployeeCircumstance] = useState("");
    const [employeeAwarness, setEmployeeAwarness] = useState("");
    const [formStatusId, setFormStatusId] = useState("");
    const [employeeCircumstanceErr, setEmployeeCircumstanceErr] = useState("");
    const [employeeAwarnessErr, setEmployeeAwarnessErr] = useState("");
    const [ctcErr, setCTCErr] = useState(false);
    const [marketRateErr, setMarketRateErr] = useState(false);
    const [vaFeedback, setVaFeedback] = useState([]);
    const [jobTitleList, setJobTitleList] = useState([]);
    const [selectedJobTitle, setSelectedJobTitle] = useState(null);
    const [vaQuestionsList, setVAQuestionsList] = useState([]);
    const [others, setOthers] = useState("");
    const [hrComments, setHRComments] = useState("");
    const [hrCommentsErr, setHRCommentsErr] = useState(false);
    const [manLoader, setmanLoader] = useState(false);

    const [userType, setUserType] = useState("");

    var userDetails =
        localStorage.getItem("argus_user") !== null
            ? localStorage.getItem("argus_user")
            : null;
    var loggedUserId =
        userDetails !== null && JSON.parse(userDetails).userid !== null
            ? JSON.parse(userDetails).userid
            : "";
    var loggedUserType =
        userDetails !== null && JSON.parse(userDetails).userid !== null
            ? JSON.parse(userDetails).usertype
            : "";


    const handleChangeJobTitle = (obj) => {

        setSelectedJobTitle(obj);
    }

    const handleChangeCircumstance = (e) => {

        if (e.target.value === "") {
            setEmployeeCircumstance(e.target.value);
            setEmployeeCircumstanceErr('Please fill out this field');
            return false;
        }
        else if ((e.target.value).length < 5) {
            setEmployeeCircumstance(e.target.value);
            setEmployeeCircumstanceErr('Minimum 5 characters');
            return false;
        }
        else {
            setEmployeeCircumstance(e.target.value);
            setEmployeeCircumstanceErr('');
        }
    };

    const handleChangeAwarness = (e) => {
        if (e.target.value === "") {
            setEmployeeAwarness(e.target.value);
            setEmployeeAwarnessErr('Please fill out this field');
            return false;
        }
        else if ((e.target.value).length < 5) {
            setEmployeeAwarness(e.target.value);
            setEmployeeAwarnessErr('Minimum 5 characters');
            return false;
        }
        else {
            setEmployeeAwarness(e.target.value);
            setEmployeeAwarnessErr('');
        }
    };

    const handleChangeCTC = (e) => {
        if (e.target.value === "") {
            setCTC(e.target.value);
            setCTCErr(true);
        }
        else {
            setCTC(e.target.value);
            setCTCErr(false);
        }
    };

    const handleChangeMarketRate = (e) => {
        if (e.target.value === "") {
            setMarketRate(e.target.value);
            setMarketRateErr(true);
        }
        else {
            setMarketRate(e.target.value);
            setMarketRateErr(false);
        }
    }

    const handleChangeHRComments = (e) => {
        if (e.target.value === "") {
            setHRComments(e.target.value);
            setHRCommentsErr(true);
        }
        else {
            setHRComments(e.target.value);
            setHRCommentsErr(false);
        }
    }

    const saveVAScores = (param) => {
        let replacedCTC;
        const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

        if (specialChars.test(ctc)) {
            replacedCTC = ctc.toString().replace(/,/g, '');
        }
        else {
            replacedCTC = ctc;
        }
        console.log(vaQuestionsList);
        if (param) {
            setmanLoader(true);

            if (orginialData.some(ques => ques.score === null)) {
                dispatch(SnackbarActions(true, 'success', 'Please fill out all the details'));
                setmanLoader(false);

                return false;
            }
            if (employeeCircumstance === "" || employeeCircumstance === null) {
                setEmployeeCircumstanceErr('Please fill out this field');
                setmanLoader(false);

                return false;
            }
            if (employeeAwarness === "" || employeeAwarness === null) {
                setEmployeeAwarnessErr('Please fill out this field');
                setmanLoader(false);

                return false
            }
            // if (ctc === "" || ctc === null) {
            //     setCTCErr(true);
            //     return false;
            // }

        }


        axiosFetch({
            method: "post",
            url: "/Performance/va/submit",
            requestConfig: {
                vaScores: vaFeedback,
                VAReview: {
                    "id": parseInt(id),
                    "EmployeeCircumstances": employeeCircumstance !== "" ? employeeCircumstance : null,
                    "AwarenessNote": employeeAwarness !== "" ? employeeAwarness : null,
                    // "JobTitleId": selectedJobTitle !== null && selectedJobTitle !== undefined ? parseInt(selectedJobTitle.value) : null,
                    // "proposedCtc": replacedCTC !== null ? parseInt(replacedCTC) : null,
                    "IsSubmit": param
                }
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    dispatch(SnackbarActions(true, 'success', 'Answers Submitted Successfully!'));
                    setmanLoader(false);

                    navigate('/value-analysis');
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate("/");
                }
            })

            .catch(err =>
                console.error(err)
            )
    }
    const handleChangeScore = (value, questionId, action) => {

        // orginialData = [...vaQuestionsList];
        if (orginialData !== undefined && orginialData.filter((obj) => obj.questionId === questionId).length !== 0) {
            orginialData.filter((obj) => obj.questionId === questionId)[0].score = parseInt(value.value);
        }
        console.log(orginialData);
        let data = [...vaFeedback];
        if (vaFeedback.length !== 0) {
            if (data.filter((obj) => obj.questionId === questionId).length !== 0) {
                data.filter((obj) => obj.questionId === questionId)[0].score = parseInt(value.value);
            }
            else {
                if (action !== undefined) {
                    data.push({
                        questionId: questionId,
                        [action.name]: parseInt(value.value),
                        id: parseInt(id),
                        employeeId: employeeId,
                    })
                }
                else {
                    data.push({
                        questionId: questionId,
                        [value.target.name]: value.target.value,
                        id: parseInt(id),
                        employeeId: employeeId,
                    })
                }
            }
        }
        else {
            if (action !== undefined) {
                data.push({
                    questionId: questionId,
                    [action.name]: parseInt(value.value),
                    id: parseInt(id),
                    employeeId: employeeId,
                })
            }
            else {
                data.push({
                    questionId: questionId,
                    [value.target.name]: value.target.value,
                    id: parseInt(id),
                    employeeId: employeeId,
                })
            }
        }

        console.log(data);
        setVaFeedback(data);
    }

    const loadVAQuestionsList = () => {
        axiosFetch({
            method: "get",
            url: `/Performance/va/questions/${id}`
        })
            .then((res) => {
                if (res.status === 200) {
                    setVAQuestionsList(res.data.vaQuestions);
                    setOthers(res.data.fields);
                    if (res.data.fields !== null) {
                        setFormStatusId(res.data.fields.statusId);
                        setEmployeeAwarness(res.data.fields.awarenessNote);
                        setEmployeeCircumstance(res.data.fields.employeeCircumstances);
                        setMarketRate(res.data.fields.marketValue);
                        setCTC(res.data.fields.proposedCTC);
                        setHRComments(res.data.fields.hrComments);
                    }
                }
                else if (res.status === 400) {

                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));

                }
                else if (res.status === 401) {
                    navigate('/');
                }
                if (res.data === "You are not an authorised user") {
                    dispatch(SnackbarActions(true, "error", res.data));
                    setTimeout(() => {
                        navigate("/value-analysis");
                    }, 3000)

                }
            })

            .catch(err => {
                console.error(err);
            })
    }
    const loadJobTitleLookup = () => {
        axiosFetch({
            method: "get",
            url: "/Lookup/jobtitles"
        })
            .then((res) => {
                if (res.status === 200) {
                    setJobTitleList(res.data);
                }
                // else if (res.status === 400) {
                //     dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                // }
                else if (res.status === 401) {
                    navigate("/");
                }
            })

            .catch(err => {
                console.error(err);
            })
    }
    const loadScoreLookup = () => {
        axiosFetch({
            method: 'get',
            url: '/Lookup/scores'
        })
            .then(res => {
                if (res.status === 200) {
                    setScores(res.data);
                }
                // else if (res.status === 400) {
                //     dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                // }
                else if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch(err => {
                console.error(err);
            })

    };
    const loadProfileDetails = () => {
        axiosFetch({
            method: "get",
            url: `/Performance/va/employee/profile/${id}`
        })
            .then((res) => {
                if (res.status === 200) {
                    if (res.data.result !== null) {
                        setProfileDetail(res.data.result);
                        setReportingPersonId(res.data.result.reportingPersonId);
                        setEmployeeId(res.data.result.id);
                        setUserType(res.data.result.userType);
                    }

                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })

            .catch(err => {
                console.error(err);
            })
    }



    useEffect(() => {
        loadProfileDetails();
        loadScoreLookup();
        loadJobTitleLookup();
        loadVAQuestionsList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        console.log(userType)
        if (others !== null) {
            setSelectedJobTitle(jobTitleList.filter(title => parseInt(title.value) === others.proposedJobTitleId)[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [others]);

    useEffect(() => {

        orginialData = [...vaQuestionsList];
    }, [vaQuestionsList]);



    const handleHRSubmit = (param) => {
        let replacedMarketRate;

        if (marketRate === "" || marketRate === null) {
            setMarketRateErr(true);
            return false;
        }
        const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        if (specialChars.test(marketRate)) {
            replacedMarketRate = marketRate.toString().replace(/,/g, '');
        }
        else {
            replacedMarketRate = marketRate;
        }

        if (!param && hrComments === "") {
            setHRCommentsErr(true);
            return false;
        }
        if (marketRate !== "" && marketRate !== null) {

            axiosFetch({
                method: "post",
                url: "/Performance/va/update",
                requestConfig: {
                    "id": id,
                    "MarketValue": replacedMarketRate,
                    "hrComments": hrComments,
                    "isSubmit": param
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        param ? dispatch(SnackbarActions(true, 'success', 'Form Completed')) : dispatch(SnackbarActions(true, 'success', 'Form Re-Assigned'));
                        setTimeout(() => {
                            navigate('/value-analysis')
                        },3000)
                    }
                    else if (res.status === 400) {
                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                    }
                    else if (res.status === 401) {
                        navigate("/");
                    }
                })

                .catch(err => {
                    console.error(err);
                })
        }
    }

    return (
        <div className="argus-pmp-module">
            {/* <Container fixed> */}
            <Grid container spacing={2} className="variable-pay-review" sx={{ marginTop: "10px", marginLeft: "-10px" }}>
                <Grid item xs={6}>
                    {/* <Card className="variable-pay"> */}
                    <h2>Team Member / Appraisee</h2>
                    <Table className="score-table review-table">
                        <TableBody>
                            <TableRow className="profile-table">
                                <TableCell>Name</TableCell>
                                <TableCell>{profileDetail !== null && profileDetail.firstName !== null ? profileDetail.lastName !== null ? profileDetail.firstName + " " + profileDetail.lastName : profileDetail.firstName : "-"}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Emp ID</TableCell>
                                <TableCell>{profileDetail !== null && profileDetail.employeeCode !== null ? profileDetail.employeeCode : "-"}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Department Name / Team Name</TableCell>
                                <TableCell>{profileDetail !== null && profileDetail.departmentName !== null ? profileDetail.departmentName : (profileDetail && profileDetail.teamName && profileDetail.teamName !== null ? + "/" + profileDetail.teamName : "-")}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Job Title</TableCell>
                                <TableCell>{profileDetail !== null && profileDetail.jobTitleName !== null ? profileDetail.jobTitleName : "-"}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Reports To</TableCell>
                                <TableCell>{profileDetail !== null && profileDetail.reportingPersonFirstName !== null ? profileDetail.reportingPersonFirstName + " " + profileDetail.reportingPersonLastName : "-"}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Current Gross[Month]</TableCell>
                                <TableCell>{profileDetail !== null && profileDetail.ctc !== null ? profileDetail.ctc : "-"}</TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>
                    {/* </Card> */}
                </Grid>
                <Grid item xs={6}>
                    <h2>Reporting Manager / Appraiser</h2>
                    <Table className="score-table review-table">
                        <TableBody>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>{profileDetail !== null && profileDetail.reportingPersonFirstName !== null ? profileDetail.reportingPersonLastName !== null ? profileDetail.reportingPersonFirstName + " " + profileDetail.reportingPersonLastName : profileDetail.reportingPersonFirstName : "-"}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Emp ID</TableCell>

                                <TableCell>{profileDetail !== null && profileDetail.reportingPersonEmpCode !== null ? profileDetail.reportingPersonEmpCode : "-"}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Department / Team Name</TableCell>
                                <TableCell>{profileDetail !== null && profileDetail.reportingPersonDepartmentName !== null ? profileDetail.reportingPersonTeam !== null ? profileDetail.reportingPersonDepartmentName + "/" + profileDetail.reportingPersonTeam : "-" : "-"}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Job Title</TableCell>
                                <TableCell>{profileDetail !== null && profileDetail.reportingPersonJobTitle !== null ? profileDetail.reportingPersonJobTitle : "-"}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table><br />
                </Grid>
            </Grid>
            {/* </Card> */}
            {/* </Container> */}
            {/* <Container fixed> */}
            <Grid container spacing={2} className="variable-pay-review" sx={{ marginTop: "10px", marginLeft: "-10px" }}>
                <Grid item xs={12}>
                    <h2>To be completed by Reporting Manager</h2>
                    <Stack sx={{ width: '100%' }} spacing={2}>
                        <Alert severity="info" sx={{ marginBottom: "20px" }}>Rank every answer as a number - 1 to 10. In all cases 1 is the lowest and 10 is highest</Alert>
                    </Stack>
                    <Table className='table-bordered argus-table score-table review-table value-scored mt-4'>
                        <TableHead>
                            <TableRow style={{ backgroundColor: "white !important" }}>
                                <TableCell colSpan={3} style={{ backgroundColor: "white !important" }} className="okr-tablehead" >Value Scorecard</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {vaQuestionsList.lenth !== 0 ? (vaQuestionsList.map((data, idx) =>
                                <TableRow key={data.id}>
                                    <TableCell>{data.questions}</TableCell>
                                    <TableCell>
                                        {formStatusId !== 1 && formStatusId !== 4 ? data.score !== null ? data.score : "-" : <Select
                                            options={scores}
                                            placholder="select"
                                            name="score"
                                            onChange={(value, action) => handleChangeScore(value, data.questionId, action)}
                                            defaultValue={data.score !== null ? scores.filter(score => parseInt(score.value) === data.score) : ""} />}
                                    </TableCell>
                                </TableRow>
                            )) : <Alert severity="error"> No Scores found </Alert>}
                        </TableBody>
                    </Table>
                    <p>Please provide your opinion on the following:</p>
                    <p className="m-b-10">Are there any personal circumstances that have changed for this person such as getting married, having kids etc that may affect their need to make more money, change job, work different hours etc?</p>
                    <TextareaAutosize
                        aria-label="empty textarea"
                        minRows={3}
                        placeholder="Fill the details here"
                        className="textarea-input desc-okr"
                        value={employeeCircumstance}
                        onChange={handleChangeCircumstance}
                        disabled={(formStatusId !== 1 && formStatusId !== 4) || parseInt(profileDetail !== null && profileDetail.reportingPersonId) !== loggedUserId}
                    />
                    {/* <span className="error-message">{employeeCircumstanceLengthErr ? "Maximum 5 characters" : ""}</span> */}
                    <span className="error-message">{employeeCircumstanceErr ? employeeCircumstanceErr : ""}</span>

                    <p className="m-b-10">Any other things the company should be aware of regarding this person, relating to their value to the company or risk of leaving?</p>
                    <TextareaAutosize
                        aria-label="empty textarea"
                        minRows={3}
                        placeholder="Fill the details here"
                        className="textarea-input desc-okr"
                        value={employeeAwarness}
                        onChange={handleChangeAwarness}
                        disabled={(formStatusId !== 1 && formStatusId !== 4) || parseInt(profileDetail !== null && profileDetail.reportingPersonId) !== loggedUserId}
                    />
                    {/* <span className="error-message">{employeeAwarnessLengthErr ? "Maximum 5 characters" : ""}</span> */}
                    <span className="error-message">{employeeAwarnessErr ? employeeAwarnessErr : ""}</span>

                    {/* <Grid container xs={12} spacing={2} className="hr-form">
                        <Grid item xs={6}>
                            <label className="form-label col-form-label">Proposed Gross:</label>
                            <NumericFormat placeholder="Proposed Gross" className="textarea-input desc-okr" thousandSeparator={true} value={ctc} onChange={handleChangeCTC} disabled={formStatusId !== 1} />
                            <span className="error-message">{ctcErr ? "Please fill out this field" : ""}</span>
                        </Grid>
                        <Grid item xs={6}>
                            <label className="form-label col-form-label">Designation:</label>
                            <Select className="custom-height-input" options={jobTitleList}
                                onChange={handleChangeJobTitle}

                                value={selectedJobTitle} isDisabled={formStatusId !== 1} />
                        </Grid>
                    </Grid> */}
                    {parseInt(profileDetail !== null && profileDetail.reportingPersonId) === loggedUserId ?
                        <Grid container xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
                            {(formStatusId !== 1 && formStatusId !== 4) ? "" : <Button variant="contained" className="theme-btn cancel-btn" sx={{ marginRight: "10px" }} onClick={() => saveVAScores(false)}>Save As Draft</Button>}
                            {(formStatusId !== 1 && formStatusId !== 4) ? "" : manLoader === true ? <CircularProgress sx={{ float: "right" }} /> : <Button variant="contained" className="theme-btn" onClick={() => saveVAScores(true)}>Submit</Button>}
                        </Grid> : ""}
                </Grid>
            </Grid>
            {/* </Container> */}
            {/* <Container> */}
            {(userType === "HRManager" || userType === "Admin" || userType === "SuperAdmin") ? "":
                <Grid container spacing={2} className="variable-pay-review" sx={{ marginTop: "10px", marginLeft: "-10px" }}>
                <Grid item xs={12}>
                    <h2>To be filled by HR</h2>
                    <p>Please indicate the current Gross of the person vs the market rate for this role:</p>
                    <form>
                        <Grid container spacing={2} xs={12}>
                            <Grid item xs={6}>
                                {/* For Indian currency use this- thousandsGroupStyle="lakh" prefix={'₹'} */}
                                <label className="form-label col-form-label">Market rate:</label>
                                <NumericFormat placeholder="Market Rate" className="textarea-input desc-okr" thousandSeparator={true} value={marketRate} onChange={handleChangeMarketRate} disabled={((userType === "HRManager" || userType === "Admin" || userType === "SuperAdmin") ? !(loggedUserId === reportingPersonId) : !(loggedUserType === "HRManager"))} />
                                <span className="error-message">{marketRateErr ? "Please fill out this field" : ""}</span>
                            </Grid>
                            <Grid item xs={6}>
                                <label className="form-label col-form-label">HR Comments :</label>
                                <TextField className="desc-okr" placeholder="Comments" value={hrComments} onChange={handleChangeHRComments}
                                    disabled={((userType === "HRManager" || userType === "Admin" || userType === "SuperAdmin") ? !(loggedUserId === reportingPersonId) : !(loggedUserType === "HRManager"))} />
                                <span className="error-message">{hrCommentsErr ? "Please fill out this field" : ""}</span>
                            </Grid>
                        </Grid><br />
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Button variant="contained" className="theme-btn" onClick={() => handleHRSubmit(true)} disabled={((userType === "HRManager" || userType === "Admin" || userType === "SuperAdmin") ? !(loggedUserId === reportingPersonId) : !(loggedUserType === "HRManager"))}>Submit</Button>
                                <Button variant="contained" className="theme-btn cancel-btn" style={{ marginRight: "10px" }} onClick={() => handleHRSubmit(false)} disabled={((userType === "HRManager" || userType === "Admin" || userType === "SuperAdmin") ? !(loggedUserId === reportingPersonId) : !(loggedUserType === "HRManager"))}>Re-Assign</Button>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            </Grid>}
            {/* </Container > */}
            <CustomizedSnackbar />
        </div >
    )
}

export default ValueAnalysisForm;